import { LoadingIndicator } from 'components/common/LoadingIndicator';
import { TextInput } from 'components/common/TextInput';
import usePushManagementDraft from 'lib/hooks/usePushManagementDraft';
import { CustomSelect } from 'components/common/CustomSelect';
import {
  PushActionHappyTabsOptions,
  PushActionTabularyTabsOptions,
  PushCardOptions,
  PushTabOptions,
} from '../constants';
import { useState } from 'react';
import { ModalMode } from '../../../layouts/ModalLayout';
import { TestPushModal } from '../../../modals/TestPushModal';
import { Modal } from '../../../modals/Modal';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { Tooltip } from 'react-tooltip';

const timeList = [
  '12:00',
  '12:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
];

const timeSelectValues = [
  ...timeList.map((time) => ({ value: `${time} AM`, label: `${time} AM` })),
  ...timeList.map((time) => ({ value: `${time} PM`, label: `${time} PM` })),
];

export const TabDraft = () => {
  const {
    onSaveNotifications,
    control,
    formState,
    fields,
    watchFields,
    isLoading,
  } = usePushManagementDraft();
  const [testNotificationId, setTestNotificationId] = useState<string | null>(
    null,
  );

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <div className="p-4">
      <Modal
        mode={ModalMode.center}
        isModalVisible={Boolean(testNotificationId)}
      >
        <TestPushModal
          notificationId={testNotificationId}
          closeModal={() => setTestNotificationId(null)}
        />
      </Modal>
      <div className="flex">
        <div className="flex-grow">
          {fields &&
            fields.map(({ id, type, days }, index) => {
              const tabType = watchFields[index]?.tabType;
              const actionHappyTabsType =
                watchFields[index]?.actionHappyTabsType;
              const isSpecificDay = watchFields[index]?.specificDay;
              const specifyDays = watchFields[index]?.days;

              return (
                <div className="pb-4 mb-4 border-b border-gray-200" key={id}>
                  <p className="text-lg mb-4">{type}</p>
                  <div className="grid grid-cols-11 gap-2 pr-6 relative">
                    <div className="col-span-2">
                      <TextInput
                        label="Push title"
                        name={`pushNotifications[${index}].dayTitle`}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                        errorStyle="text-sm text-red-400 absolute -bottom-5"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                        control={control}
                        isDisabled={isSpecificDay}
                      />
                    </div>
                    <div className="col-span-2">
                      <TextInput
                        label="Push message"
                        name={`pushNotifications[${index}].dayMessage`}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                        errorStyle="text-sm text-red-400 absolute -bottom-5"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                        control={control}
                        isDisabled={isSpecificDay}
                      />
                    </div>
                    <div className="">
                      <CustomSelect
                        label="Push time"
                        name={`pushNotifications[${index}].deliveryTime`}
                        labelStyle="block mb-2"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                        control={control}
                        options={timeSelectValues}
                        isDisabled={isSpecificDay}
                      />
                    </div>
                    <div className="">
                      <CustomSelect
                        label="Day Specific"
                        name={`pushNotifications[${index}].specificDay`}
                        labelStyle="block mb-2"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                        control={control}
                        options={[
                          { value: true, label: 'Yes' },
                          { value: false, label: 'No' },
                        ]}
                      />
                    </div>
                    <div className="">
                      <CustomSelect
                        label="Active"
                        name={`pushNotifications[${index}].active`}
                        labelStyle="block mb-2"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                        control={control}
                        options={[
                          { value: true, label: 'Yes' },
                          { value: false, label: 'No' },
                        ]}
                        isDisabled={isSpecificDay}
                      />
                    </div>
                    <div className="">
                      <CustomSelect
                        label="Tab type"
                        name={`pushNotifications[${index}].tabType`}
                        labelStyle="block mb-2"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                        control={control}
                        options={PushTabOptions}
                        isDisabled={isSpecificDay}
                      />
                    </div>
                    <div className="">
                      {tabType === 'happy_tabs' && (
                        <CustomSelect
                          label="Action"
                          name={`pushNotifications[${index}].actionHappyTabsType`}
                          labelStyle="block mb-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                          control={control}
                          options={PushActionHappyTabsOptions}
                          isDisabled={isSpecificDay}
                        />
                      )}
                      {tabType === 'tabulary' && (
                        <CustomSelect
                          label="Action"
                          name={`pushNotifications[${index}].actionTabularyTabsType`}
                          labelStyle="block mb-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                          control={control}
                          options={PushActionTabularyTabsOptions}
                          isDisabled={isSpecificDay}
                        />
                      )}
                    </div>
                    <div className="">
                      {tabType === 'happy_tabs' && (
                        <CustomSelect
                          label="Card"
                          name={`pushNotifications[${index}].cardType`}
                          labelStyle="block mb-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                          control={control}
                          options={PushCardOptions}
                          isDisabled={isSpecificDay}
                        />
                      )}
                    </div>
                    <div className="">
                      {tabType === 'happy_tabs' &&
                        actionHappyTabsType &&
                        actionHappyTabsType !== 'compose' && (
                          <CustomSelect
                            label="Unflip"
                            name={`pushNotifications[${index}].unflipAllTabs`}
                            labelStyle="block mb-2"
                            controlStyle="bg-blue-30 mb-4 w-full relative"
                            control={control}
                            options={[
                              { value: true, label: 'Yes' },
                              { value: false, label: 'No' },
                            ]}
                            isDisabled={isSpecificDay}
                          />
                        )}
                    </div>
                    {!isSpecificDay && days[0] && (
                      <div className="absolute top-10 h-12 right-0">
                        <HiOutlineDotsVertical
                          id={`tooltip-${index}`}
                          className="h-5 w-5 cursor-pointer"
                        />
                        <Tooltip
                          anchorSelect={`#tooltip-${index}`}
                          place="bottom-start"
                          clickable
                          openOnClick
                          style={{
                            padding: '8px',
                            backgroundColor: '#fff',
                            color: '000',
                            zIndex: '40',
                          }}
                          border="1px solid rgb(0 0 0 / 0.1)"
                        >
                          <button
                            type="button"
                            className="text-gray-800 text-sm p-2 hover:bg-gray-100 rounded"
                            onClick={() => {
                              setTestNotificationId(days[0].id);
                            }}
                          >
                            Send test push
                          </button>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                  <div>
                    {isSpecificDay &&
                      days?.map((day, dayIndex) => (
                        <div
                          className="grid grid-cols-11 gap-2 pr-6 relative"
                          key={day.id}
                        >
                          <div className="col-span-2">
                            <TextInput
                              label={`${day.day?.toUpperCase()} Push title`}
                              name={`pushNotifications[${index}].days[${dayIndex}].specificDayTitle`}
                              labelStyle="block text-sm text-gray-400 mb-2"
                              inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                              errorStyle="text-sm text-red-400 absolute -bottom-3"
                              controlStyle="bg-blue-30 w-full relative"
                              control={control}
                            />
                          </div>
                          <div className="col-span-2">
                            <TextInput
                              label={`${day.day?.toUpperCase()} Push message`}
                              name={`pushNotifications[${index}].days[${dayIndex}].specificDayMessage`}
                              labelStyle="block text-sm text-gray-400 mb-2"
                              inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                              errorStyle="text-sm text-red-400 absolute -bottom-2"
                              controlStyle="bg-blue-30 w-full relative"
                              control={control}
                            />
                          </div>
                          <div className="">
                            <CustomSelect
                              label="Push time"
                              labelStyle="block mb-2"
                              controlStyle="bg-blue-30 w-full relative"
                              name={`pushNotifications[${index}].days[${dayIndex}].deliveryTime`}
                              control={control}
                              options={timeSelectValues}
                            />
                          </div>
                          <div className="" />
                          <div className="">
                            <CustomSelect
                              label="Active"
                              labelStyle="block mb-2"
                              controlStyle="bg-blue-30 w-full relative"
                              name={`pushNotifications[${index}].days[${dayIndex}].active`}
                              control={control}
                              options={[
                                { value: true, label: 'Yes' },
                                { value: false, label: 'No' },
                              ]}
                            />
                          </div>
                          <div className="">
                            <CustomSelect
                              label="Tab type"
                              name={`pushNotifications[${index}].days[${dayIndex}].tabType`}
                              labelStyle="block mb-2"
                              controlStyle="bg-blue-30 mb-4 w-full relative"
                              control={control}
                              options={PushTabOptions}
                            />
                          </div>
                          <div className="">
                            {specifyDays[dayIndex]?.tabType ===
                              'happy_tabs' && (
                              <CustomSelect
                                label="Action"
                                name={`pushNotifications[${index}].days[${dayIndex}].actionHappyTabsType`}
                                labelStyle="block mb-2"
                                controlStyle="bg-blue-30 mb-4 w-full relative"
                                control={control}
                                options={PushActionHappyTabsOptions}
                              />
                            )}
                            {specifyDays[dayIndex]?.tabType === 'tabulary' && (
                              <CustomSelect
                                label="Action"
                                name={`pushNotifications[${index}].days[${dayIndex}].actionTabularyTabsType`}
                                labelStyle="block mb-2"
                                controlStyle="bg-blue-30 mb-4 w-full relative"
                                control={control}
                                options={PushActionTabularyTabsOptions}
                              />
                            )}
                          </div>
                          <div className="">
                            {specifyDays[dayIndex]?.tabType ===
                              'happy_tabs' && (
                              <CustomSelect
                                label="Card"
                                name={`pushNotifications[${index}].days[${dayIndex}].cardType`}
                                labelStyle="block mb-2"
                                controlStyle="bg-blue-30 mb-4 w-full relative"
                                control={control}
                                options={PushCardOptions}
                              />
                            )}
                          </div>
                          <div className="">
                            {specifyDays[dayIndex]?.tabType === 'happy_tabs' &&
                              specifyDays[dayIndex]?.actionHappyTabsType &&
                              specifyDays[dayIndex]?.actionHappyTabsType !==
                                'compose' && (
                                <CustomSelect
                                  label="Unflip"
                                  name={`pushNotifications[${index}].days[${dayIndex}].unflipAllTabs`}
                                  labelStyle="block mb-2"
                                  controlStyle="bg-blue-30 mb-4 w-full relative"
                                  control={control}
                                  options={[
                                    { value: true, label: 'Yes' },
                                    { value: false, label: 'No' },
                                  ]}
                                />
                              )}
                          </div>
                          <div className="absolute top-10 h-12 right-0">
                            <HiOutlineDotsVertical
                              id={`tooltip-${day.id}`}
                              className="h-5 w-5 cursor-pointer"
                            />
                            <Tooltip
                              anchorSelect={`#tooltip-${day.id}`}
                              place="bottom-start"
                              clickable
                              openOnClick
                              style={{
                                padding: '8px',
                                backgroundColor: '#fff',
                                color: '000',
                                zIndex: '40',
                              }}
                              border="1px solid rgb(0 0 0 / 0.1)"
                            >
                              <button
                                type="button"
                                className="text-gray-800 text-sm p-2 hover:bg-gray-100 rounded"
                                onClick={() => {
                                  setTestNotificationId(day.id);
                                  window.document.body.click();
                                }}
                              >
                                Send test push
                              </button>
                            </Tooltip>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              );
            })}
        </div>
        <div className="flex flex-col justify-end w-32 relative">
          <div className="w-full p-2 bg-blue-30 mb-10 sticky bottom-2">
            <button
              type="button"
              className="bg-blue-500 text-white rounded py-2 px-2 items-center h-[44px] w-full text-center"
              disabled={!formState.isValid}
              onClick={() => onSaveNotifications()}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
